import React, { useMemo } from 'react';
import SlotRenderer from '@plone/volto/components/theme/SlotRenderer/SlotRenderer';
import config from '@plone/registry';
import { useMediaQuery } from 'usehooks-ts';
import MenuMobile from '@redturtle/qubicaamf-theme/components/Blocks/PageTitleWithMenu/menumobile';
import MenuDesktop from '@redturtle/qubicaamf-theme/components/Blocks/PageTitleWithMenu/menudesktop';
import type { QubicaContentProps } from '@redturtle/qubicaamf-theme/components/View/Common/utils';
import { useSlotContentIsLoaded } from '@redturtle/qubicaamf-theme/helpers/hooks/useContentIsLoaded.hook';

import '@redturtle/qubicaamf-theme/components/Blocks/Products/productstitle.scss';
import styles from './styles.module.css';
import type {
  BlogExpanders,
  MacroCategoriesBehavior,
} from '@redturtle/qubicaamf-theme/components/View/NewsTestimonialsView/NewsTestimonialView';

interface Content extends QubicaContentProps, MacroCategoriesBehavior {
  '@components': BlogExpanders;
}
interface Props
  extends Omit<React.ComponentProps<typeof SlotRenderer>, 'content'> {
  content: Content;
}

const BlogPageHeader = (props: Props) => {
  const { content } = props;
  const contentLoaded = useSlotContentIsLoaded(content);
  const Container = config.getComponent('Container').component || 'div';
  const isMobile = useMediaQuery('(max-width: 1199px)');

  const items = useMemo(
    () =>
      content?.['@components']?.blog_summary?.news_macro_types?.map((item) => ({
        ...item,
        active:
          item['@id'] === content?.news_macro_type?.[0]?.['@id'] ||
          item['@id'] === content['@id'],
      })) ?? [],
    [content],
  );

  return contentLoaded ? (
    <Container className={styles.blogPageHeaderContainer}>
      {isMobile ? (
        <MenuMobile
          items={items}
          id={'blog-macrocategory-navigation'}
          title={content.title}
          parent_title={'News'}
          titleasp={true}
        />
      ) : (
        <MenuDesktop
          items={items}
          isEditMode={false}
          title={content.title}
          parent_title={'News'}
          titleasp={true}
        />
      )}
    </Container>
  ) : null;
};

export { BlogPageHeader };
